import React from 'react'

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError(props, state) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true }
    }

    componentDidCatch(error, info) {
        // You can also log the error to an error reporting service
        this.setState({ erro: error, info: info })
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <>
                    <h1>Erro geral na aplicação de Transparência</h1>
                </>
            )
        }

        return this.props.children
    }
}
